import {ProfileLogsViewProps} from "./types";
import {useMemo} from "react";
import ItemsHorizontalScroll from "../../../cap17drive/shared/itemsHorizontalScroll/itemsHorizontalScroll";
import ItemTmdbBtnV2 from "../../../shared/itemTmdbBtnV2/itemTmdbBtnV2";
import {Spinner} from "../../../shared";
import {useSelector} from "react-redux";
import users from "../../../users";
import useSquadflixNavigate from "../../../cap17drive/squadflixHome/useSquadflixNavigate";

type UserViewLog = {
    item: any;
    type: 'movie' | 'tv' | 'live' | 'episode';
    view_time?: number;
    started_at?: Date;
    viewed_at?: Date;
    episode?: number;
    season?: number;
    lastEpisode?: number;
    canNavigate?: boolean;
}

const ProfileLogsView = ({userViewRecord, loading, tmdbItems, canNavigate}: ProfileLogsViewProps) => {

    const darkMode = useSelector(users.selectors.isDarkMode)
    const squadflixNav = useSquadflixNavigate({});

    const logsArray = useMemo(() => {
        const arr: UserViewLog[] = [];

        const processViewItem = (view) => {
            if (view.episodes?.length) {
                view.episodes.forEach(ep => {
                    processViewItem(ep);
                });
            } else {
                const item = tmdbItems[view.itemId];
                if (item) {
                    arr.push({
                        item,
                        type: view.type,
                        view_time: view.view_time,
                        started_at: view.started_at ? new Date(view.started_at) : undefined,
                        viewed_at: view.viewed_at ? new Date(view.viewed_at) : undefined,
                        episode: view.episode,
                        season: view.season,
                    });
                }
            }
        };

        if (userViewRecord?.views?.length) {
            userViewRecord.views.forEach(view => processViewItem(view));
        }

        // Ordenar por fecha vista
        arr.sort((a, b) => {
            const dateA = a.viewed_at ? a.viewed_at.getTime() : 0;
            const dateB = b.viewed_at ? b.viewed_at.getTime() : 0;
            return dateA - dateB; // más antiguo primero
        });

        // Agrupar episodios consecutivos del mismo show
        const grouped: UserViewLog[] = [];
        for (const element of arr) {
            const current = element;
            const lastGroup = grouped[grouped.length - 1];

            // Condición para seguir la secuencia
            const sameShow = lastGroup &&
                current.type === 'episode' &&
                lastGroup.type === 'episode' &&
                lastGroup.item.id === current.item.id &&
                lastGroup.season === current.season;

            if (sameShow) {
                // Si el episodio es consecutivo, extendemos el rango
                if (
                    typeof lastGroup.lastEpisode === 'number' &&
                    current.episode === lastGroup.lastEpisode + 1
                ) {
                    lastGroup.lastEpisode = current.episode;
                    lastGroup.viewed_at = current.viewed_at || lastGroup.viewed_at;
                }
                    // Si no es consecutivo, pero sigue siendo el mismo show,
                // lo consideramos parte del mismo bloque si está muy cerca en tiempo (ej. vistos seguidos)
                else if (
                    lastGroup.viewed_at &&
                    current.viewed_at &&
                    current.viewed_at.getTime() - lastGroup.viewed_at.getTime() < 1000 * 60 * 30 // 30 minutos
                ) {
                    lastGroup.lastEpisode = current.episode;
                    lastGroup.viewed_at = current.viewed_at;
                } else {
                    // Si rompe la secuencia, empezamos un nuevo grupo
                    grouped.push({...current, lastEpisode: current.episode});
                }
            } else {
                // Primer episodio o tipo distinto
                grouped.push({...current, lastEpisode: current.episode});
            }
        }

        // Ordenar descendente para mostrar los más recientes primero
        return grouped.sort((a, b) => {
            const dateA = a.viewed_at ? a.viewed_at.getTime() : 0;
            const dateB = b.viewed_at ? b.viewed_at.getTime() : 0;
            return dateB - dateA;
        });
    }, [tmdbItems, userViewRecord.views]);

    if (loading) {
        return <div className="d-flex justify-content-center align-items-center" style={{
            padding: "20px",
            height: "237px",
        }}>
            <Spinner className={undefined}/>
        </div>;
    }


    return <ItemsHorizontalScroll>
        {logsArray.map((log, index) => (
            <ItemTmdbBtnV2
                onClick={!canNavigate ? undefined : (e) => {
                    if (log.item.isMovie) {
                        squadflixNav.navigateToMovie(log.item);
                    } else {
                        squadflixNav.navigateToSerie(log.item);
                    }
                }}
                tmdbItem={log.item}
                key={index}
                type={log.type}
                bottomInfo={log.type === 'episode' && <>
                    {log.lastEpisode && log.lastEpisode !== log.episode
                        ? `S${log.season}E${log.episode}-E${log.lastEpisode}`
                        : `S${log.season}E${log.episode}`}
                </>}
                description={log.viewed_at.toLocaleDateString() + " " + log.viewed_at.toLocaleTimeString()}/>
        ))}
        {logsArray.length === 0 && <div className="text-muted" style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "227px",
        }}>No hay registros de visualización.</div>}
    </ItemsHorizontalScroll>;
}

export default ProfileLogsView;
